<template>
  <div class="forgeron-footer forgeron-custom-footer" style="margin-left: 16rem; width: calc(100% - 16rem)">
    <div class="footer-content d-flex justify-content-between align-items-center">
      <div
        class="row w-100 ms-0"
        style="
          line-height: 60px;
          background-color: var(--sidebar-secondary-background);
          font-weight: bold;
          font-size: 1rem;
        "
      >
        <div class="col-3 col-md-3 px-0 pl-2 px-md-2">
          <Link :href="route(routeName, getParams(previousDate()))" class="previous" style="color: #d3d3d3">
            « {{ getDisplayFormat('previous') }}
          </Link>
        </div>
        <div class="col-6 px-0 px-md-2px text-center">
          <input
            :type="getInputType()"
            :value="getInputValue()"
            class="text-center"
            style="background: transparent; border: none; color: #ceae43; font-weight: 700"
            @change="changeDate($event, route)"
          />
        </div>
        <div class="col-3 col-md-3 px-0 pr-2 px-md-2" style="text-align: right">
          <Link :href="route(routeName, getParams(nextDate()))" class="next" style="color: #d3d3d3">
            {{ getDisplayFormat('next') }} »
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link, router } from '@inertiajs/vue3';
import moment from 'moment';
import { ref } from 'vue';

export default {
  components: {
    Link,
  },
  props: {
    activeDate: { type: String, default: '2037-07-03' },
    step: { type: String, default: 'days' },
    routeName: { type: String, default: null },
  },
  emits: [],
  setup(props) {
    const currentDate = ref(moment(props.activeDate));

    const changeDate = ($event, route) => {
      let newDate;
      if (props.step === 'weeks') {
        newDate = moment($event.target.value, 'YYYY-WW');
      } else {
        newDate = moment($event.target.value);
      }

      router.get(route(props.routeName, getParams(newDate)));
    };

    const previousDate = () => {
      return currentDate.value.clone().subtract(1, props.step);
    };

    const nextDate = () => {
      return currentDate.value.clone().add(1, props.step);
    };

    const getParams = (date) => {
      return {
        date: getDateParam(date),
        year: getYearParam(date),
        month: getMonthParam(date),
        week: getWeekParam(date),
      };
    };

    const getDateParam = (date) => {
      if (props.step !== 'days') {
        return null;
      }

      return date.format('YYYY-MM-DD');
    };

    const getYearParam = (date) => {
      if (props.step !== 'years' && props.step !== 'months' && props.step !== 'weeks') {
        return null;
      }

      return date.format('YYYY');
    };

    const getMonthParam = (date) => {
      if (props.step === 'days' || props.step === 'weeks' || props.step === 'years') {
        return null;
      }

      return date.format('MM');
    };

    const getWeekParam = (date) => {
      if (props.step === 'years' || props.step === 'months' || props.step === 'days') {
        return null;
      }

      return date.format('WW');
    };

    const getDisplayFormat = (dateType = 'current') => {
      let date = getDate(dateType);

      switch (props.step) {
        case 'days':
          return date.format('DD.MM.');
        case 'weeks':
          return date.format('YYYY-WW');
        case 'months':
          return date.format('MMMM YYYY');
        case 'years':
          return date.format('YYYY');
      }
    };

    const getDate = (dateType = 'current') => {
      switch (dateType) {
        case 'previous':
          return previousDate();
        case 'next':
          return nextDate();
        default:
          return currentDate.value;
      }
    };

    const getInputType = () => {
      switch (props.step) {
        case 'years':
          return 'text';
        case 'months':
          return 'month';
        case 'weeks':
          return 'week';
        case 'days':
        default:
          return 'date';
      }
    };

    const getInputValue = (dateType = 'current') => {
      let date = getDate(dateType);

      switch (props.step) {
        case 'days':
          return date.format('YYYY-MM-DD');
        case 'weeks':
          return date.format('YYYY-WW');
        case 'months':
          return date.format('YYYY-MM');
        case 'years':
          return date.format('YYYY');
      }
    };

    return {
      changeDate,
      currentDate,
      getDisplayFormat,
      getInputType,
      getInputValue,
      getParams,
      previousDate,
      nextDate,
    };
  },
};
</script>
